import React from 'react';
import PropTypes from 'prop-types';
import {
  PAPER_TABS,
  Spacing_Base,
  FontSize_Css_Plus,
} from '../../../data/common';
import { strParse } from '../../../lib/util';

function DTypeTestRow({ vocaList = {}, startNo, tab, config }) {
  // console.log('vocabList D:', vocaList);
  return (
    <div
      style={{
        width: '100%',
        marginTop: `${config?.spacing * Spacing_Base}px`,
      }}
    >
      {tab !== PAPER_TABS.ANSWER && (
        <div
          style={{
            fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
            fontWeight: 700,
            fontFamily: "'Pretendard', Arial, sans-serif",
          }}
        >
          ※&nbsp;{vocaList?.title}
        </div>
      )}
      <div>
        {vocaList?.questions?.map((voca, idx) => {
          return (
            <div
              key={`${voca.questions}-${String(idx)}`}
              style={{
                marginTop: `${config?.spacing * Spacing_Base}px`,
                fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                display: 'grid',
                gridTemplateColumns: '1.2fr 8.8fr',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: '5px',
                fontFamily: "'Pretendard', Arial, sans-serif",
                width: '100%',
              }}
            >
              <div
                style={{
                  flexShrink: 0,
                  minWidth: '10px',
                  fontFamily: "'Pretendard', Arial, sans-serif",
                }}
              >
                {startNo + idx}.
              </div>
              {(tab === PAPER_TABS.TEST_PAPER ||
                tab === PAPER_TABS.ANSWER_TEST_PAPER) && (
                <div style={{ fontFamily: "'Pretendard', Arial, sans-serif" }}>
                  <div
                    style={{
                      fontFamily: "'Pretendard', Arial, sans-serif",
                      marginBottom: '5px',
                    }}
                  >
                    {strParse(voca.question)}
                  </div>
                  <div>
                    {voca.synonyms.map((word, idx) => {
                      return (
                        <div
                          key={`${word.type}-${String(idx)}`}
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            gap: '5px',
                            minHeight: '18px',
                            marginBottom: '4px',
                            fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                            fontFamily: "'Pretendard', Arial, sans-serif",
                          }}
                        >
                          <div
                            style={{
                              flexShrink: 0,
                              minWidth: '25px',
                              minHeight: '18px',
                              paddingTop: '5px',
                              fontFamily: "'Pretendard', Arial, sans-serif",
                            }}
                          >
                            -&nbsp;({word.type})
                          </div>
                          <div
                            style={{
                              borderBottom: '1px solid #000',
                              minWidth: '100px',
                              minHeight: '18px',
                              display: 'flex',
                              fontFamily: "'Pretendard', Arial, sans-serif",
                              justifyContent: 'center',
                              alignItems: 'flex-end',
                              paddingBottom: '3px',
                            }}
                          >
                            {tab === PAPER_TABS.TEST_PAPER && ''}
                            {tab === PAPER_TABS.TEST_PAPER &&
                              config?.vocaFirstWordShow && (
                                <div
                                  style={{
                                    width: '100%',
                                    minHeight: '18px',
                                    textAlign: 'left',
                                  }}
                                >
                                  {word?.answer[0]}
                                </div>
                              )}
                            {tab === PAPER_TABS.ANSWER_TEST_PAPER &&
                              word.answer}
                          </div>
                          <div
                            style={{
                              minHeight: '18px',
                              paddingTop: '5px',
                              display: 'flex',
                              flexWrap: 'wrap',
                              fontFamily: "'Pretendard', Arial, sans-serif",
                            }}
                          >
                            {word.meaning}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                {tab === PAPER_TABS.ANSWER &&
                  voca?.synonyms?.map((word, idx) => {
                    return (
                      <div key={`${word.type}-${String(idx)}`}>
                        {word?.answer}
                        <span>
                          {idx !== voca?.synonyms?.length - 1 && `,`}&nbsp;
                        </span>
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

DTypeTestRow.propTypes = {
  vocaList: PropTypes.object,
  startNo: PropTypes.number,
  tab: PropTypes.string.isRequired,
  config: PropTypes.object,
};

export default DTypeTestRow;
